export default __webpack_public_path__ + "static/media/img-bounty-rewards.6a02b7cb.png";